import { Close } from "@mui/icons-material";
import { Confirm, ConfirmProps } from "react-admin";

import { color, shadows, space } from "../theme/designTokens";

export const CustomConfirm = (props: ConfirmProps) => {
  return (
    <Confirm
      CancelIcon={Close}
      sx={{
        "& .MuiDialogContent-root": {
          marginTop: space.xxs,
          padding: `${space.xl}px ${space.xxl}px`,
        },
        "& .MuiDialogActions-root": {
          paddingTop: space.xs,
          paddingBottom: space.sm,
          justifyContent: "flex-end",
          flexDirection: "row-reverse",
        },
        "& .MuiButton-root": {
          backgroundColor: color.secondaryButtonBackground,
          color: color.typographyBase,
          boxShadow: shadows.secondary,
          padding: `${space.sm}px ${space.xl}px`,
          marginLeft: `${space.xl}px`,
          "&:hover": {
            backgroundColor: color.secondaryButtonHover,
          },
        },
        "& .MuiButton-root.ra-confirm": {
          backgroundColor: `${color.primary} !important`,
          color: `${color.white} !important`,
          "&:hover": {
            backgroundColor: `${color.hover} !important`,
          },
        },
        "& .MuiDialogTitle-root": {
          backgroundColor: color.background,
          padding: `${space.xl}px ${space.xxl}px`,
        },
      }}
      {...props}
    />
  );
};
